<template>
  <div class="px-4 pb-4 sm:px-6 sm:pb-6">
    <h1 class="my-2">{{ t("headings.partners") }}</h1>
    <breadcrumb class="mt-3 mb-4" />
    <div class="card">
      <custom-table
        :fields="fields"
        :items="partners"
        :loading="waiting"
        :pagination="true"
        :perPage="10"
        :searchable="true"
        :searchFields="searchFields"
        :showHeader="true"
        sortBy="name"
        :sortFields="sortFields"
        @row-click="(id) => router.push(`/partners/${id}`)"
      >
        <template #header>
          <span class="flex justify-end"
            ><form-button
              :command="() => router.push('/partners/create')"
              id="header-partner-create-button"
              label="create_partner"
              textVariant="white"
              type="button"
              variant="indigo"
          /></span>
        </template>
        <template #cell(types)="{ item }">
          <div class="flex items-center">
            {{
              item.types
                .map((partnerType) =>
                  t("partner_types." + getTypeName(partnerType, types))
                )
                .join(", ")
            }}
          </div>
        </template>
        <template #cell(licenceValidity)="{ value }">
          {{ getLocaleDate(locale, value) }}
        </template>
      </custom-table>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import Breadcrumb from "../components/breadcrumb/Breadcrumb.vue";
import FormButton from "../components/form/FormButton.vue";
import CustomTable from "../components/table/CustomTable.vue";
import { getLocaleDate } from "../utils/dateUtils";
import { getTypeName } from "../utils/typeUtils";
export default {
  components: { Breadcrumb, CustomTable, FormButton },
  setup() {
    const router = useRouter();
    const store = useStore();
    const { locale, t } = useI18n();

    const partners = computed(() => store.state.partner.partners);
    const types = computed(() => store.state.partner.types);

    const fields = ref([
      {
        key: "name",
        label: "name",
      },
      {
        key: "types",
        label: "type",
      },
      {
        key: "licenceValidity",
        label: "licence_validity",
      },
      {
        key: "email",
        label: "email",
      },
      {
        key: "phone",
        label: "phone",
      },
    ]);

    const searchFields = ref([
      {
        key: "name",
        label: "name",
      },
      {
        key: "email",
        label: "email",
      },
      {
        key: "phone",
        label: "phone",
      },
    ]);

    const sortFields = ref([
      {
        key: "name",
        label: "name",
      },
    ]);

    onMounted(() => {
      if (!partners.value.length) {
        store.dispatch("partner/getPartners");
      }
      if (!types.value.length) {
        store.dispatch("partner/getTypes");
      }
    });

    return {
      fields,
      getLocaleDate,
      getTypeName,
      locale,
      partners,
      router,
      searchFields,
      sortFields,
      t,
      types,
      waiting: computed(() => store.state.partner.waiting),
    };
  },
};
</script>
